import React from "react";
import styles from "./SidebarContentContainer.module.css";
import { useSidebarContext } from "../../contexts/SidebarContext";
import VesselTracker from "./SidebarContent/VesselTracker";
import SearchVessel from "./SidebarContent/SearchVessel";
import ChatList from "./SidebarContent/ChatList";
import ChatMessage from "./SidebarContent/ChatMessage";
import WarningZoneList from "./SidebarContent/WarningZoneList";
import WarningZoneForm from "./SidebarContent/WarningZoneForm";
import WarningZoneVesselList from "./SidebarContent/WarningZoneVesselList";
import WarningZoneChatMessage from "./SidebarContent/WarningZoneChatMessage";

const SidebarContent: React.FC = () => {
    const { contentType } = useSidebarContext();
    let content: React.ReactNode = null;
    switch (contentType) {
        case "searchVessel":
            content = <SearchVessel />;
            break;
        case "tracker":
            content = <VesselTracker />;
            break;
        case "chatList":
            content = <ChatList />;
            break;
        case "chatMessage":
            content = <ChatMessage />;
            break;
        case "warningZoneList":
            content = <WarningZoneList />;
            break;
        case "warningZoneCreateForm":
            content = <WarningZoneForm type="create" />;
            break;
        case "warningZoneUpdateForm":
            content = <WarningZoneForm type="edit" />;
            break;
        case "warningZoneVesselList":
            content = <WarningZoneVesselList />;
            break;
        case "warningZoneChatMessage":
            content=<WarningZoneChatMessage />;
            break;
        case "none":
        default:
            content = null;
    }
    return (
        <div className={styles["side-bar-content"] + " text"}>
            {content}
        </div>
    );
};

export default SidebarContent;